<template>
  <DocumentsContainer />
</template>

<script lang="ts">
import Vue from "vue";
import DocumentsContainer from "@/components/projects/project/documents/container/DocumentsContainer.vue";

export default Vue.extend({
  components: {
    DocumentsContainer,
  },
});
</script>
